import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ResellerSignUp } from '@/features/auth/reseller-sign-up'

const searchSchema = z.object({
  token: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/signup/reseller')({
  validateSearch: searchSchema,
  component: ResellerSignUp,
})
